module.exports = __webpack_public_path__ + "e510bffa65c0a4ccf93229568764b595.svg";